import { Link } from "wouter";

/** KontrataPH wordmark — "Kontrata" in navy, "PH" in red, with the arrow mark. */
export function Logo({ light = false, withTagline = false }: { light?: boolean; withTagline?: boolean }) {
  const navy = light ? "#ffffff" : "#0f2540";
  return (
    <Link href="/" className="flex items-center gap-2 shrink-0">
      <img src="/KontrataPH-Icon.svg" width="30" height="30" alt="KontrataPH" className="shrink-0" style={{ height: 30, width: "auto" }} />
      <span className="leading-none">
        <span className="text-[19px] font-extrabold tracking-tight" style={{ color: navy }}>
          Kontrata<span style={{ color: "#e0313e" }}>PH</span>
        </span>
        {withTagline && (
          <span className={`block text-[10px] font-medium ${light ? "text-white/70" : "text-mut"}`}>
            Trabaho. Serbisyo. Negosyo. Kontrata.
          </span>
        )}
      </span>
    </Link>
  );
}
